"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.readNoteVal = exports._MapNoteFields = void 0;
var cash_dom_1 = __importDefault(require("cash-dom"));
/**
 * adds an event listener to save the note value of each data-note element after each change event to local storage
 * @param module
 */
var _MapNoteFields = function (module) {
    var refContainer = (0, cash_dom_1.default)(module);
    var noteFields = refContainer.find('[data-note]');
    //console.log('module', refContainer);
    //console.log('found', noteFields.length, 'note fields!');
    var storage = JSON.parse(localStorage.getItem('note') || '{}');
    var saveToStorage = function (noteValue, value) {
        if (value) {
            storage[noteValue] = value;
        }
        else {
            delete storage[noteValue]; // Remove from storage if value is undefined
        }
        localStorage.setItem('note', JSON.stringify(storage));
    };
    noteFields.each(function (index, element) {
        var $element = (0, cash_dom_1.default)(element);
        var noteValue = $element.data('note'); // Get the data-note value
        // Get the data attributes of each element
        var val = (0, exports.readNoteVal)($element);
        console.log('found note element with val', noteValue, ':', val);
        if (val) {
            storage[noteValue] = val;
        }
        $element.on('change', function () {
            var newVal = (0, exports.readNoteVal)($element); // Get the updated value
            console.log('note element updated', noteValue, ':', newVal);
            saveToStorage(noteValue, newVal); // Save the new value to localStorage
        });
    });
    localStorage.setItem('note', JSON.stringify(storage));
};
exports._MapNoteFields = _MapNoteFields;
var readNoteVal = function (elem) {
    var val = elem.val() || elem.text() || '';
    // Special handling for radio buttons
    if (elem.prop('type') === 'radio') {
        if (elem.prop('checked')) {
            val = elem.val() || '';
        }
        else {
            val = ''; // Skip if the radio button is not selected
        }
    }
    return val;
};
exports.readNoteVal = readNoteVal;
